import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21.17", x2: "12", y1: "8", y2: "8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Chrome";
const Chrome = memo(themed(Icon));
export {
  Chrome
};
//# sourceMappingURL=chrome.js.map
